import { keycloak } from "../../..";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useGetUserStatusQuery } from "../../../features/portal/user/userApi";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { AUTH_LOCALSTORAGE_NAME } from "../../../constants/constants";

const getStoredUserEmail = () => {
  const tokenEmail = (keycloak?.tokenParsed as any)?.email;
  if (tokenEmail) return tokenEmail;

  const savedAuth = localStorage.getItem(AUTH_LOCALSTORAGE_NAME);
  if (!savedAuth) return "";

  try {
    const parsedAuth = JSON.parse(savedAuth);
    return (
      parsedAuth?.user?.data?.userData?.email ||
      parsedAuth?.user?.data?.email ||
      parsedAuth?.user?.email ||
      ""
    );
  } catch (error) {
    return "";
  }
};

export default function AccountDeactivated() {
  const navigate = useNavigate();
  const email = useMemo(getStoredUserEmail, []);
  const { data, isFetching, refetch } = useGetUserStatusQuery(email, {
    skip: !email,
  });

  useEffect(() => {
    if (
      data?.data?.enabled === true &&
      data?.data?.isCompanyPublished !== false
    ) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [data?.data?.enabled, data?.data?.isCompanyPublished, navigate]);

  const handleLogout = async () => {
    try {
      localStorage.clear();
      await keycloak.logout();
    } catch (error) {
      localStorage.clear();
      window.location.assign("/");
    }
  };
  const notice =
    data?.data?.isCompanyPublished === false
      ? "Your business account is unpublished. Please contact your admin."
      : "Your account has been deactivated. Please contact your admin.";

  return (
    <SidebarLayout isHide isLogoTitle hideHeaderActions>
      <div className="flex min-h-[calc(100vh-9.5rem)] items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-[30px] font-semibold leading-tight text-[#343A40]">
            {notice}
          </h1>
          {email && (
            <button
              type="button"
              onClick={() => refetch()}
              disabled={isFetching}
              className="mt-6 mr-4 text-base font-medium text-[#343A40] underline underline-offset-4 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {isFetching ? "Checking..." : "Check status again"}
            </button>
          )}
          <button
            type="button"
            onClick={handleLogout}
            className="mt-6 text-base font-medium text-[#ff6b00] underline underline-offset-4"
          >
            Logout
          </button>
        </div>
      </div>
    </SidebarLayout>
  );
}
